// Admin-specific Payment Processors mock (no SA dependencies)

export interface AdminUsageFunction {
  id: string;
  label: string;
  enabled: boolean;
}

export interface AdminPaymentProcessor {
  id: string;
  name: string;
  order: number;
  icon: string;
  logoColor: string;
  enabled: boolean;
  isDefault: boolean;
  category: 'api' | 'manual';
  testMode: boolean;
  usageFunctions: AdminUsageFunction[];
  commissionPercent: number;
  commissionFixed: number;
  lastTest: string | null;
}

export interface AdminAnnualLicenseConfig {
  title: string;
  description: string;
  priceLabel: string;
  price: number;
  currency: string;
  badge: string;
  features: string[];
  note: string;
}

export const adminPaymentProcessors: AdminPaymentProcessor[] = [
  {
    id: 'stripe',
    name: 'Stripe',
    order: 1,
    icon: 'ri-bank-card-line',
    logoColor: 'bg-violet-100 text-violet-600',
    enabled: true,
    isDefault: true,
    category: 'api',
    testMode: false,
    usageFunctions: [
      { id: 'subscriptions', label: 'Suscripciones', enabled: true },
      { id: 'one_off', label: 'Pago único', enabled: true },
      { id: 'marketplace', label: 'Marketplace', enabled: false },
    ],
    commissionPercent: 2.9,
    commissionFixed: 0.30,
    lastTest: '2026-06-28 14:22',
  },
  {
    id: 'paypal',
    name: 'PayPal',
    order: 2,
    icon: 'ri-paypal-line',
    logoColor: 'bg-sky-100 text-sky-600',
    enabled: true,
    isDefault: false,
    category: 'api',
    testMode: true,
    usageFunctions: [
      { id: 'subscriptions', label: 'Suscripciones', enabled: true },
      { id: 'one_off', label: 'Pago único', enabled: true },
    ],
    commissionPercent: 3.49,
    commissionFixed: 0.49,
    lastTest: '2026-06-28 14:25',
  },
  {
    id: 'mercado_pago',
    name: 'Mercado Pago',
    order: 3,
    icon: 'ri-hand-coin-line',
    logoColor: 'bg-sky-100 text-sky-600',
    enabled: true,
    isDefault: false,
    category: 'api',
    testMode: false,
    usageFunctions: [
      { id: 'subscriptions', label: 'Suscripciones', enabled: true },
      { id: 'one_off', label: 'Pago único', enabled: true },
    ],
    commissionPercent: 4.39,
    commissionFixed: 0,
    lastTest: '2026-06-28 14:20',
  },
  {
    id: 'bank_transfer',
    name: 'Transferencia Bancaria',
    order: 4,
    icon: 'ri-bank-line',
    logoColor: 'bg-amber-100 text-amber-600',
    enabled: true,
    isDefault: false,
    category: 'manual',
    testMode: false,
    usageFunctions: [{ id: 'manual', label: 'Pago manual', enabled: true }],
    commissionPercent: 0,
    commissionFixed: 0,
    lastTest: null,
  },
  {
    id: 'crypto',
    name: 'Cripto (USDT)',
    order: 5,
    icon: 'ri-bit-coin-line',
    logoColor: 'bg-amber-100 text-amber-600',
    enabled: false,
    isDefault: false,
    category: 'manual',
    testMode: false,
    usageFunctions: [],
    commissionPercent: 0,
    commissionFixed: 0,
    lastTest: null,
  },
];

export const adminDefaultAnnualLicenseConfig: AdminAnnualLicenseConfig = {
  title: 'Licencia Anual',
  description: 'Configuración de licencia anual para radios. Descuento del 20% sobre el plan mensual al contratar 12 meses.',
  priceLabel: 'USD / año',
  price: 199,
  currency: 'USD',
  badge: 'Ahorrá 20%',
  features: [
    '12 meses de servicio ininterrumpido',
    'Descuento del 20% vs plan mensual',
    'Soporte prioritario 24/7',
    'Dominio personalizado incluido',
  ],
  note: 'La licencia se renueva automáticamente al finalizar el período. Podés cancelar en cualquier momento.',
};